import { capitalize, capitalizeAll } from '@/helpers/string';
export default function (Vue) {
    Vue.filter(`capitalize`, (word) => capitalize(word));
    Vue.filter(`capitalizeAll`, (word) => capitalizeAll(word));
}
